export interface EventName {
    start?: 'mousedown' | 'touchstart';
    move?: 'mousemove' | 'touchmove';
    end?: 'mouseup' | 'touchend';
    cancel?: 'touchcancel';
    contextmenu?: 'contextmenu';
    keydown?: 'keydown';
}

export interface TouchBackendOptions {
    enableTouchEvents?: boolean;
    enableKeyboardEvents?: boolean;
    enableMouseEvents?: boolean;
    ignoreContextMenu?: boolean;
    touchSlop?: number;
}

export interface DragSourceOptions {
    delayTouchStart?: number;
    dropEffect?: string;
    dragAngleRanges?: AngleRange[];
}

export interface AngleRange {
    start: number;
    end: number;
}

export enum ListenerType {
    mouse = 'mouse',
    touch = 'touch',
    keyboard = 'keyboard',
}
